import {REPORT_TEAMS_SENIOR_COACH} from '/enum/records.enum';

export default {
  reportName: REPORT_TEAMS_SENIOR_COACH,
};
